// extracted by mini-css-extract-plugin
export default {"container":"FavoritesTab_container__JfAOg","tab":"FavoritesTab_tab__mpH5Z","selected":"FavoritesTab_selected__95XII","upload":"FavoritesTab_upload__x-cTj"};